import { UTSLocale } from "@smile2impress/attraction-constants";
import { getLocalizedPathname } from "modules/localize-pathnames/getLocalizedPathname";

import { UrlsConfig } from "configs/urlsConfig";
import { UTSLocaleToI18nLocale } from "constants/enum";

import { PromoCampaign } from "./CampaignProvider.types";

const UrlsConfigExcluded = [
    UrlsConfig.WHITENING,
    UrlsConfig.BOOKING_WIDGET,
    UrlsConfig.BOOKING_WIDGET_SCROLLER,
    UrlsConfig.REFERRAL,
    UrlsConfig.REFERRAL_FOR_FRIENDS,
    UrlsConfig.REFERRAL_FOR_FRIENDS_NON_PATIENTS,
    UrlsConfig.REFERRAL_NON_PATIENTS,
    UrlsConfig.QUIZ_COMPLETED,
    UrlsConfig.SMILE_VISION_OFFER,
    UrlsConfig.ULTRA_FORM,
];

const localizedUrlsConfigExcluded = Object.values(UTSLocale).reduce(
    (acc: Record<UTSLocale, string[]>, utsLocale: UTSLocale) => {
        const i18nLocale = UTSLocaleToI18nLocale[utsLocale as UTSLocale];
        acc[utsLocale as UTSLocale] = UrlsConfigExcluded.map(
            (url) =>
                `/${i18nLocale}${getLocalizedPathname(url, i18nLocale, true)}`
        ).filter((url) => url !== undefined) as string[];
        return acc;
    },
    {} as Record<UTSLocale, string[]>
);

const stripPathname = (pathname: string) => {
    return pathname.indexOf("?") > -1 ? pathname.split("?")[0] : pathname;
};

export const findActiveCampaigns = (
    campaigns: PromoCampaign[],
    pathname: string,
    currentLocale: UTSLocale
): PromoCampaign | null => {
    const now = new Date();
    const strippedPathname = stripPathname(pathname);
    const active = campaigns.find((campaign) => {
        const { locale, firstDay, lastDay, excludedPages } = campaign;
        if (locale !== currentLocale) return false;
        const firstDayDate = new Date(firstDay);
        if (firstDayDate > now) return false;
        const lastDayDate = new Date(lastDay);
        if (lastDayDate < now) return false;
        if (
            excludedPages.some((page) => {
                return page === strippedPathname;
            })
        )
            return false;
        if (
            localizedUrlsConfigExcluded[currentLocale].some((page) => {
                return page === strippedPathname;
            })
        )
            return false;
        return true;
    });

    if (active) {
        return active;
    } else {
        return null;
    }
};
